import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';

interface LoginMethodsSettings {
  phoneOtp: boolean;
  emailPassword: boolean;
  googleLogin: boolean;
}

const defaultSettings: LoginMethodsSettings = {
  phoneOtp: true,
  emailPassword: true,
  googleLogin: true,
};

export function useLoginMethods() {
  const [settings, setSettings] = useState<LoginMethodsSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const settingsDoc = await getDoc(doc(db, 'settings', 'loginMethods'));
        
        if (settingsDoc.exists()) {
          const data = settingsDoc.data();
          setSettings({
            phoneOtp: data.phoneOtp !== false, // Default to true if not set
            emailPassword: data.emailPassword !== false, // Default to true if not set
            googleLogin: data.googleLogin !== false, // Default to true if not set
          });
        } else {
          // Use default settings if document doesn't exist
          setSettings(defaultSettings);
        }
      } catch (err) {
        console.error('Error loading login methods settings:', err);
        setError('Failed to load login methods settings');
        // Use default settings as fallback
        setSettings(defaultSettings);
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  return {
    settings,
    loading,
    error
  };
}
